/*
 * Clubhouse meetup, city hub and Find a club pages on craftclubco.com (ADR-0005; docs/clubs-shopify.md).
 * The club page carries its own copy of this logic (sections/clubhouse-club.liquid). Everything a
 * search engine needs is already in the HTML; this adds the sharer's ref, the view beacon, times
 * in the right zone, the short guest RSVP / Join form (Turnstile), live meetup counts, craft chips
 * and search.
 * Source of truth: shopify/theme in the clubhouse repo.
 */
(function () {
  var root = document.querySelector('[data-cc-page]');
  if (!root || root.dataset.ccReady) return;
  root.dataset.ccReady = '1';
  var api = (root.dataset.api || 'https://learn.craftclubco.com').replace(/\/$/, '');
  var page = root.dataset.ccPage;
  var slug = root.dataset.slug || '';
  var TERMS_VERSION = 'meetup-2026-10'; // packages/core CLUB_TERMS.meetup.version

  // --- The sharer's ref: kept for the visit, sent with the view and the form. ---
  var ref = null;
  try {
    var fromUrl = new URLSearchParams(location.search).get('ref');
    if (fromUrl && /^[a-z0-9_-]{1,40}$/i.test(fromUrl)) sessionStorage.setItem('cc_ref', fromUrl);
    ref = sessionStorage.getItem('cc_ref');
  } catch (e) {}

  function post(path, body) {
    return fetch(api + path, {
      method: 'POST',
      headers: { 'content-type': 'application/json' },
      body: JSON.stringify(body),
      keepalive: true,
    });
  }

  post('/api/public/view', {
    page_type: page === 'meetup' ? 'meetup' : 'directory',
    slug: slug,
    ref: ref || undefined,
  }).catch(function () {});

  // --- Times: in-person meetups in their own zone, online ones in the visitor's. ---
  function fmt(iso, tz, opts) {
    try {
      return new Intl.DateTimeFormat(
        'en-AU',
        Object.assign({ timeZone: tz || undefined }, opts),
      ).format(new Date(iso));
    } catch (e) {
      return new Intl.DateTimeFormat('en-AU', opts).format(new Date(iso));
    }
  }
  function clock(iso, tz) {
    return fmt(iso, tz, { hour: 'numeric', minute: '2-digit' })
      .replace(':00', '')
      .replace(/\s/g, '')
      .toLowerCase();
  }
  document.querySelectorAll('[data-cc-date]').forEach(function (el) {
    var iso = el.getAttribute('datetime');
    if (!iso) return;
    var tz = el.dataset.online ? undefined : el.dataset.tz;
    var kind = el.dataset.ccDate;
    if (kind === 'block') {
      el.textContent = '';
      var w = document.createElement('span');
      w.textContent = fmt(iso, tz, { weekday: 'short' }).toUpperCase();
      var d = document.createElement('strong');
      d.textContent = fmt(iso, tz, { day: 'numeric' });
      var m = document.createElement('span');
      m.textContent = fmt(iso, tz, { month: 'short' }).toUpperCase();
      el.append(w, d, m);
    } else if (kind === 'span') {
      var zone = fmt(iso, tz, { timeZoneName: 'short' }).split(' ').pop();
      el.textContent =
        clock(iso, tz) + (el.dataset.end ? '–' + clock(el.dataset.end, tz) : '') + ' ' + zone;
    } else if (kind === 'when') {
      el.textContent =
        fmt(iso, tz, { weekday: 'long', day: 'numeric', month: 'long' }) +
        ', ' +
        clock(iso, tz) +
        (el.dataset.end ? '–' + clock(el.dataset.end, tz) : '') +
        ' ' +
        fmt(iso, tz, { timeZoneName: 'short' }).split(' ').pop();
    } else if (kind === 'short') {
      el.textContent = fmt(iso, tz, { weekday: 'short', day: 'numeric', month: 'short' });
    } else {
      el.textContent = fmt(iso, tz, { day: 'numeric', month: 'long', year: 'numeric' });
    }
  });

  // --- Share ---
  document.querySelectorAll('[data-cc-share]').forEach(function (b) {
    b.addEventListener('click', function () {
      var url = location.origin + location.pathname;
      var label = b.querySelector('span') || b;
      if (navigator.share) {
        navigator.share({ title: b.dataset.title, url: url }).catch(function () {});
      } else if (navigator.clipboard) {
        navigator.clipboard.writeText(url).then(function () {
          var was = label.textContent;
          label.textContent = 'Link copied';
          setTimeout(function () {
            label.textContent = was;
          }, 2000);
        });
      }
    });
  });

  // --- Guest RSVP / Join: first name, email and one tick ---
  var forms = document.querySelectorAll('[data-cc-form]');
  if (forms.length) {
    var s = document.createElement('script');
    s.src = 'https://challenges.cloudflare.com/turnstile/v0/api.js';
    s.async = true;
    s.defer = true;
    document.head.appendChild(s);
  }
  var ERRORS = {
    invalid: 'Check your name and email, and tick the box.',
    bot_check: 'The security check didn’t go through. Try again.',
    not_found: 'This isn’t taking new people right now.',
    terms: 'The meetup terms changed. Reload the page and try again.',
    slow_down: 'That’s a lot of tries. Give it a minute.',
  };
  forms.forEach(function (form) {
    var note = form.querySelector('.cc-form__note');
    var button = form.querySelector('button[type=submit]');
    function say(text, bad) {
      note.hidden = false;
      note.textContent = text;
      note.classList.toggle('cc-form__note--bad', !!bad);
    }
    form.addEventListener('submit', function (e) {
      e.preventDefault();
      if (!form.reportValidity()) return;
      var data = new FormData(form);
      var token = data.get('cf-turnstile-response');
      if (!token) return say('Wait a moment for the security check, then try again.', true);
      var kind = form.dataset.ccForm;
      var body = {
        first_name: String(data.get('first_name') || '').trim(),
        email: String(data.get('email') || '').trim(),
        over_18: data.get('agree') === 'on',
        terms_version: TERMS_VERSION,
        marketing_opt_in: false,
        ref: ref || undefined,
        captcha_token: token,
      };
      body[kind === 'rsvp' ? 'event_slug' : 'club_slug'] = form.dataset.slug;
      button.disabled = true;
      post('/api/public/' + kind, body)
        .then(function (res) {
          return res
            .json()
            .catch(function () {
              return {};
            })
            .then(function (j) {
              return { ok: res.ok && j.ok, error: j.error };
            });
        })
        .then(function (r) {
          if (r.ok) {
            form.querySelectorAll('input, button').forEach(function (i) {
              i.disabled = true;
            });
            say(
              kind === 'rsvp'
                ? 'Check your email to confirm your spot. The link signs you in to the Clubhouse.'
                : 'Check your email to confirm. The link signs you in to the Clubhouse.',
            );
          } else {
            button.disabled = false;
            say(ERRORS[r.error] || 'That didn’t go through. Try again.', true);
            if (window.turnstile) window.turnstile.reset();
          }
        })
        .catch(function () {
          button.disabled = false;
          say('No connection. Try again in a moment.', true);
        });
    });
  });

  // --- Meetup: live counts (counts only, never who), cancelled and finished ---
  if (page === 'meetup' && slug) {
    fetch(api + '/api/public/events/' + encodeURIComponent(slug))
      .then(function (r) {
        return r.ok ? r.json() : null;
      })
      .then(function (j) {
        var ev = j && j.event;
        var live = root.querySelector('[data-cc-live]');
        var bar = root.querySelector('[data-cc-bar-live]');
        if (!ev) return;
        var text = '';
        if (ev.cancelled) text = 'This meetup was cancelled.';
        else if (ev.finished) text = 'This meetup has finished. See the club for the next one.';
        else if (ev.spots_left === 0) text = 'Full · RSVP to join the waitlist';
        else if (ev.going_count > 0)
          text =
            ev.going_count +
            ' going' +
            (ev.spots_left ? ' · ' + ev.spots_left + ' spots left' : '');
        else if (ev.spots_left) text = ev.spots_left + ' spots';
        if (text && live) {
          live.textContent = text;
          live.hidden = false;
        }
        if (bar && !ev.cancelled && !ev.finished)
          bar.textContent = (ev.spots_left ? ev.spots_left + ' spots left · ' : '') + 'free';
        if (ev.cancelled || ev.finished) {
          root
            .querySelectorAll('[data-cc-form] input, [data-cc-form] button')
            .forEach(function (i) {
              i.disabled = true;
            });
          var b = root.querySelector('[data-cc-bar]');
          if (b) b.remove();
        }
      })
      .catch(function () {});
  }

  // --- Sticky bar: shows once the RSVP card has scrolled up out of view ---
  var bar = root.querySelector('[data-cc-bar]');
  var card = root.querySelector('#rsvp');
  if (bar && card && 'IntersectionObserver' in window) {
    new IntersectionObserver(function (es) {
      var e = es[0];
      bar.hidden = e.isIntersecting || e.boundingClientRect.top > 0;
    }).observe(card);
  }

  // --- City hub: craft chips (a club page's craft chip links here with ?craft=) ---
  var chips = root.querySelectorAll('[data-cc-craft]');
  chips.forEach(function (chip) {
    chip.addEventListener('click', function () {
      var craft = chip.dataset.ccCraft;
      chips.forEach(function (c) {
        c.setAttribute('aria-pressed', String(c === chip));
      });
      var shown = 0;
      root.querySelectorAll('[data-cc-cards] > .cc-card').forEach(function (cardEl) {
        var crafts = (cardEl.dataset.crafts || '').split('|');
        var match = !craft || crafts.indexOf(craft) >= 0 || crafts.indexOf('Anything goes') >= 0;
        cardEl.hidden = !match;
        if (match) shown++;
      });
      var none = root.querySelector('[data-cc-none]');
      if (none) none.hidden = shown > 0;
    });
  });
  try {
    var want = new URLSearchParams(location.search).get('craft');
    if (want)
      chips.forEach(function (c) {
        if (c.dataset.ccCraft === want) c.click();
      });
  } catch (e) {}

  // --- Find a club: search and Near me through the public API ---
  var search = root.querySelector('[data-cc-search]');
  if (search) {
    var results = root.querySelector('[data-cc-results]');
    var list = root.querySelector('[data-cc-results-list]');
    var title = root.querySelector('[data-cc-results-title]');
    function card(c) {
      var li = document.createElement('li');
      li.className = 'cc-card';
      var a = document.createElement('a');
      a.className = 'cc-card__link';
      a.href = '/pages/clubs/' + encodeURIComponent(c.slug);
      var crest = document.createElement('img');
      crest.className = 'cc-card__crest';
      crest.src = api + '/api/og/club/' + encodeURIComponent(c.slug) + '/crest';
      crest.alt = '';
      crest.width = 52;
      crest.height = 58;
      var body = document.createElement('span');
      body.className = 'cc-card__body';
      var h = document.createElement('h3');
      h.className = 'cc-card__title';
      h.textContent = c.name;
      var meta = document.createElement('span');
      meta.className = 'cc-card__meta';
      var place =
        c.format === 'online'
          ? 'Online'
          : [c.locality, c.region].filter(Boolean).join(', ') +
            (c.format === 'both' ? ' + online' : '');
      meta.textContent =
        place + (c.distance_km != null ? ' · ' + Math.round(c.distance_km) + ' km away' : '');
      var p = document.createElement('span');
      p.className = 'cc-card__line';
      p.textContent = (c.description || '').slice(0, 110);
      body.append(h, meta, p);
      a.append(crest, body);
      li.appendChild(a);
      return li;
    }
    function show(params, label) {
      results.hidden = false;
      title.textContent = 'Looking…';
      list.innerHTML = '';
      fetch(api + '/api/public/clubs?' + new URLSearchParams(params))
        .then(function (r) {
          return r.json();
        })
        .then(function (j) {
          var clubs = (j && j.clubs) || [];
          title.textContent = clubs.length ? label : 'No clubs there yet. Why not start one?';
          clubs.forEach(function (c) {
            list.appendChild(card(c));
          });
        })
        .catch(function () {
          title.textContent = 'Couldn’t search just now. Try again.';
        });
    }
    search.addEventListener('submit', function (e) {
      e.preventDefault();
      var q = String(new FormData(search).get('q') || '').trim();
      if (q) show({ q: q, limit: '30' }, 'Clubs for “' + q + '”');
    });
    var near = root.querySelector('[data-cc-near]');
    if (near && navigator.geolocation) {
      near.addEventListener('click', function () {
        navigator.geolocation.getCurrentPosition(
          function (pos) {
            show(
              {
                near: pos.coords.latitude.toFixed(3) + ',' + pos.coords.longitude.toFixed(3),
                radius_km: '50',
                limit: '30',
              },
              'Clubs near you',
            );
          },
          function () {
            results.hidden = false;
            title.textContent = 'Location is off. Search by suburb instead.';
          },
          { maximumAge: 600000, timeout: 10000 },
        );
      });
    } else if (near) {
      near.hidden = true;
    }
  }
})();
